import { Component, OnInit } from '@angular/core';
import { FooterComponent } from '../../../components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HostingService } from '../../../services/hosting.service';
import { Hosting } from '../../../models/HostingModel';
import { NavbarComponent} from "../../../components/navbar/navbar.component";
import { AuthService } from '../../../services/auth.service';
import { DetailComponent } from '../../estadias/detail/detail.component';
@Component({
  selector: 'app-inventario',
  imports: [FooterComponent, CommonModule, NavbarComponent,DetailComponent],
  templateUrl: './inventario.component.html',
  styleUrls: ['./inventario.component.css'],
  standalone: true
})
export class InventarioComponent implements OnInit {
  alojamientos: Hosting[] = [];
  alojamientoSeleccionado: any = null;
  cargando: boolean = true;

  constructor(
    private router: Router,
    private hostingService: HostingService,
    private authService:AuthService
  ) { }

  ngOnInit() {
    //this.cargarAlojamientos();
    //this.cargarAlojamientosByAdminId();

  }

    onHostingSelectedFromDetail(hosting: Hosting) {
    this.alojamientos = [hosting];
    console.log('EVENTOOOO',this.alojamientos)
    this.cargando = false;
   
}
  async cargarAlojamientos() {
    this.cargando = true;
    const allHostings = await this.hostingService.getAllHostings();
    this.alojamientos = allHostings;
    console.log('[DEBUG] Alojamientos completos:', this.alojamientos);
    this.cargando = false;
  }


  async cargarAlojamientosByAdminId() {
    this.cargando = true;
    const allHostings = await this.hostingService.getHostingsByAdminIds();
    this.alojamientos = allHostings;
    console.log('[DEBUG] Alojamientos completos:', this.alojamientos);
    this.cargando = false;
  }

   async cargarAlojamientosByRecepcionId() {
    this.cargando = true;
    const allHostings = await this.hostingService.getAllHostingIdRecepcion();
    this.alojamientos = allHostings;
    console.log('[DEBUG] Alojamientos completos:', this.alojamientos);
    this.cargando = false;
  }

  seleccionarAlojamiento(alojamiento: any) {
    this.alojamientoSeleccionado = alojamiento;
    console.log('ALOJAMIENTOOO')
     console.log(this.alojamientoSeleccionado)
  }

  irAGestionarProductos() {
    if (this.alojamientoSeleccionado) {
      this.router.navigate(
        ['/admin-hotel/inventario/gestionar-productos'],
        {
          queryParams: {
            alojamientoId: this.alojamientoSeleccionado.id,
            alojamientoName: this.alojamientoSeleccionado.name
          }
        }
      );
    }
  }

  irAListarProductos() {
    if (this.alojamientoSeleccionado) {
      this.router.navigate(['/admin-hotel/inventario/listar-productos'], { queryParams: { alojamientoId: this.alojamientoSeleccionado.id } });
    }
  }

  irAEliminarProductos() {

  }
}